import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import styles from './entity_block_line_search_label.module.scss';

type Props = {
  label: string | JSX.Element;
  indent?: boolean;
  isHovered: boolean;
};

export const EntityBlockLineSearchLabel: FC<Props> = ({
  label,
  indent,
  isHovered,
}) => (
  <span
    className={classNames(styles.label, {
      [styles.indent]: indent,
    })}
  >
    <span>{label}</span>
    <span
      className={classNames(styles.searchText, {
        [styles.hoverLabel]: isHovered,
      })}
    >
      <FormattedMessage id="entity/expertises/EntityBlockLineSearchLabel.tsx/1" />
      <MaterialIcon
        name="arrow_forward"
        className={classNames(styles.searchIcon, {
          [styles.hoverIcon]: isHovered,
        })}
      />
    </span>
  </span>
);
